<template>
    <div class="month_calendar left_panel_item">
        <div class="top_nav">
            <button class="btn_white" @click="action_BeforeMonth"><v-icon>mdi-chevron-left</v-icon></button>
            <div class="month">{{ thisMonthString }}</div>
            <button class="btn_white" @click="action_NextMonth"><v-icon>mdi-chevron-right</v-icon></button>
            <button class="btn_white btn_xs left" @click="action_Today">{{ $t('reservationwindow.leftpannel.button_today_title') }}</button>
        </div>
        <div class="date_wrap">
            <ul class="weeks">
                <li>{{ $t('reservationwindow.leftpannel.label_sunday') }}</li>
                <li>{{ $t('reservationwindow.leftpannel.label_monday') }}</li>
                <li>{{ $t('reservationwindow.leftpannel.label_tuesday') }}</li>
                <li>{{ $t('reservationwindow.leftpannel.label_wednesday') }}</li>
                <li>{{ $t('reservationwindow.leftpannel.label_thursday') }}</li>
                <li>{{ $t('reservationwindow.leftpannel.label_friday') }}</li>
                <li>{{ $t('reservationwindow.leftpannel.label_saturday') }}</li>
            </ul>
            <!-- 날짜 시작 -->
            <ul class="days">
                <DayItem v-for="date in dateArray" :key="date.toString()"
                    :today="today"
                    :selectedDate="selectedDate"
                    :date="date"
                    :currentMonth="currentMonth"
                />
            </ul>
        </div>
    </div>
</template>


<script>
import DayItem from './DatePickerItem.vue'
import { setSelectedDate, sheetAxis } from '../../../sheet-axis'
import { handleRefresh } from '../../../sheet-refresh'
import moment from '@/util/MPMoment'
export default {
    components: { DayItem },
    data() {
        return {
            sheetAxis,
            currentMonth: moment()
        }
    },
    watch: {
        'sheetAxis.selectedDate': {
            handler: function(newValue) {
                if (newValue == undefined) { return }
                this.currentMonth = moment(newValue).startOf('months')
                handleRefresh()
            }
        }
    },
    computed: {
        today: function() {
            return moment().startOf('days')
        },
        selectedDate: function() {
            return moment(this.sheetAxis.selectedDate)
        },
        thisMonthString: function() {
            return this.currentMonth.format(this.$t('reservationwindow.leftpannel.label_date'))
        },
        dateArray: function() {
            let startDate = moment(this.currentMonth).startOf('months').startOf('weeks')
            let array = []
            for (let i=0 ; i<7*6 ; i++) {
                let d = moment(startDate).add(i, 'days').startOf('days')
                array.push(moment(d))
            }

            return array
        }
    },
    methods: {
        action_BeforeMonth() {
            this.currentMonth = moment(this.currentMonth).add(-1, 'months')
        },
        action_NextMonth() {
            this.currentMonth = moment(this.currentMonth).add(1, 'months')
        },
        action_Today() {
            setSelectedDate(moment().startOf('days'))
        },
    }
}
</script>